export default class DatavalidationService {
  getAll(mode, type, date1, date2) {
    return fetch("https://api.tradersr.com/api/datavalidation?mode=" + mode + "&type=" + type + "&date1=" + date1 + "&date2=" + date2)
      .then(res => res.json());
  }
}